import React, { useState, useContext, createContext, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import BulkEnquiryDialog from "@/components/BulkEnquiryDialog";
import Home from "@/pages/Home";
import Recipes from "@/pages/Recipes";
import Blogs from "@/pages/Blogs";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

// Global enquiry-dialog context so any button on any page can open the same popup
const EnquiryContext = createContext({ open: () => {} });
export const useEnquiry = () => useContext(EnquiryContext);

function PublicLayout({ children }) {
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [initialGrade, setInitialGrade] = useState("");
  const open = useCallback((grade = "") => {
    setInitialGrade(grade || "");
    setEnquiryOpen(true);
  }, []);
  const close = () => setEnquiryOpen(false);

  return (
    <EnquiryContext.Provider value={{ open }}>
      <Navbar onEnquire={() => open()} />
      {children}
      <Footer />
      <WhatsAppFAB />
      <BulkEnquiryDialog open={enquiryOpen} initialGrade={initialGrade} onClose={close} />
    </EnquiryContext.Provider>
  );
}

function AppRoutes() {
  const loc = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);
  const isAdmin = loc.pathname.startsWith("/admin");
  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    );
  }
  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/recipes" element={<Recipes />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:slug" element={<BlogDetail />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </PublicLayout>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <Toaster position="top-center" richColors closeButton />
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}
